import { Button, Flex, Space, Tooltip, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

import { getLocalDate } from '../../../utils/getLocalDate';
import {
    broadcastSegmentationNames,
    broadcastStatusNames,
    statusList,
} from './options';

const { Text, Link } = Typography;

export const getColumns = (
    getColumnSearchProps,
    updateFilters,
    viewBroadcast
) => [
    {
        title: <StyledTilte>Название</StyledTilte>,
        dataIndex: 'title',
        key: 'title',
        render: title => <StyledName>{title}</StyledName>,
        ...getColumnSearchProps('title', 'названию'),
    },

    {
        title: <StyledTilte>Сегментация</StyledTilte>,
        dataIndex: 'segmentation',
        key: 'segmentation',
        render: segmentation => (
            <Flex>
                <StyledText>
                    {broadcastSegmentationNames[segmentation] || '-'}
                </StyledText>
            </Flex>
        ),
    },

    {
        title: <StyledTilte>Дата отправки</StyledTilte>,
        dataIndex: 'send_at',
        key: 'send_at',
        render: send_at => (
            <Flex>
                <Text>{getLocalDate(send_at)}</Text>
            </Flex>
        ),
    },

    {
        title: <StyledTilte>Статус</StyledTilte>,
        dataIndex: 'status',
        filters: statusList,
        filterDropdown: ({ close }) => (
            <div style={{ padding: 8 }}>
                <Flex vertical gap={8}>
                    {statusList.map((status, index) => (
                        <Text
                            style={{ cursor: 'pointer' }}
                            key={index}
                            onClick={() => {
                                close();
                                updateFilters({ status: status.value });
                            }}
                        >
                            {status.label}
                        </Text>
                    ))}
                </Flex>
            </div>
        ),
        render: status => (
            <Button
                size={'small'}
                style={{
                    cursor: 'not-allowed',
                    pointerEvents: 'none',
                }}
            >
                <Space>{broadcastStatusNames[status]}</Space>
            </Button>
        ),
    },

    {
        title: (
            <StyledTilte>
                Результат{' '}
                <Tooltip title={'Запланировано/Успешно/Не успешно'}>
                    <QuestionCircleOutlined />
                </Tooltip>{' '}
            </StyledTilte>
        ),
        render: ({
            total_sends,
            failed_sends,
        }: {
            total_sends: number;
            failed_sends: number;
        }) => (
            <Flex>
                <Text>
                    {total_sends || '-'} / {total_sends - failed_sends || '-'} /{' '}
                    {failed_sends || '-'}
                </Text>
            </Flex>
        ),
    },

    {
        title: '',
        key: 'operation',
        fixed: 'right',
        render: ({ id }) => (
            <StyledLink onClick={() => viewBroadcast(id)}>Подробнее</StyledLink>
        ),
    },
];

const StyledTilte = styled(Text)`
    white-space: nowrap;
    font-weight: 600;
`;

const StyledLink = styled(Link)`
    white-space: nowrap;
`;

const StyledName = styled(Text)`
    display: block;
    white-space: nowrap;
    width: 296px;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 992px) {
        width: 200px;
    }
`;

const StyledText = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 108px;
`;
